(() => {
  function bind(section) {
    if (section.dataset.pdpZoomBound) return;
    const dialog = section.querySelector('[data-pdp-zoom]');
    const items = [...section.querySelectorAll('[data-pdp-zoom-open]')];
    if (!dialog || !items.length || typeof dialog.showModal !== 'function') return;
    section.dataset.pdpZoomBound = 'true';

    const image = dialog.querySelector('[data-pdp-zoom-image]');
    const stage = dialog.querySelector('[data-pdp-zoom-stage]');
    const position = dialog.querySelector('[data-pdp-zoom-position]');
    const output = dialog.querySelector('[data-pdp-zoom-scale]');
    const zoomIn = dialog.querySelector('[data-pdp-zoom-in]');
    const zoomOut = dialog.querySelector('[data-pdp-zoom-out]');
    const previous = dialog.querySelector('[data-pdp-zoom-previous]');
    const next = dialog.querySelector('[data-pdp-zoom-next]');
    let index = 0;
    let scale = 1;
    let panX = 0;
    let panY = 0;
    let gesture = null;
    let opener = null;

    function draw() {
      const maxX = Math.max(0, (image.offsetWidth * scale - stage.clientWidth) / 2);
      const maxY = Math.max(0, (image.offsetHeight * scale - stage.clientHeight) / 2);
      panX = Math.max(-maxX, Math.min(maxX, panX));
      panY = Math.max(-maxY, Math.min(maxY, panY));
      image.style.transform = `translate(${panX}px, ${panY}px) scale(${scale})`;
      output.value = `${Math.round(scale * 100)}%`;
      zoomOut.disabled = scale <= 1;
      zoomIn.disabled = scale >= 3;
      stage.dataset.zoomed = scale > 1 ? 'true' : 'false';
    }

    function setScale(value) {
      scale = Math.max(1, Math.min(3, value));
      if (scale === 1) { panX = 0; panY = 0; }
      draw();
    }

    function select(nextIndex) {
      index = (nextIndex + items.length) % items.length;
      const item = items[index];
      image.src = item.dataset.zoomSrc;
      image.alt = item.dataset.zoomAlt || '';
      position.textContent = `${index + 1} / ${items.length}`;
      previous.hidden = items.length < 2;
      next.hidden = items.length < 2;
      setScale(1);
    }

    items.forEach((item, itemIndex) => item.addEventListener('click', () => {
      opener = item;
      select(itemIndex);
      dialog.showModal();
      dialog.querySelector('[data-pdp-zoom-close]').focus();
    }));
    dialog.querySelector('[data-pdp-zoom-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      image.removeAttribute('src');
      opener?.focus({ preventScroll: true });
      opener = null;
    });
    zoomIn.addEventListener('click', () => setScale(scale + 0.5));
    zoomOut.addEventListener('click', () => setScale(scale - 0.5));
    previous.addEventListener('click', () => select(index - 1));
    next.addEventListener('click', () => select(index + 1));
    image.addEventListener('load', draw);
    window.addEventListener('resize', () => { if (dialog.open) draw(); });

    dialog.addEventListener('keydown', (event) => {
      const rtl = getComputedStyle(dialog).direction === 'rtl';
      if (event.key === 'ArrowLeft') { event.preventDefault(); select(index + (rtl ? 1 : -1)); }
      if (event.key === 'ArrowRight') { event.preventDefault(); select(index + (rtl ? -1 : 1)); }
    });

    stage.addEventListener('pointerdown', (event) => {
      if (event.button !== 0 && event.pointerType === 'mouse') return;
      gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, panX, panY };
      stage.setPointerCapture(event.pointerId);
    });
    stage.addEventListener('pointermove', (event) => {
      if (!gesture || gesture.id !== event.pointerId || scale === 1) return;
      panX = gesture.panX + event.clientX - gesture.x;
      panY = gesture.panY + event.clientY - gesture.y;
      draw();
    });
    stage.addEventListener('pointerup', (event) => {
      if (!gesture || gesture.id !== event.pointerId) return;
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      if (scale === 1 && items.length > 1 && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        const rtl = getComputedStyle(dialog).direction === 'rtl';
        select(index + (dx < 0 ? (rtl ? -1 : 1) : (rtl ? 1 : -1)));
      }
      gesture = null;
    });
    stage.addEventListener('pointercancel', () => { gesture = null; });
  }

  function initialize(root = document) {
    root.querySelectorAll('.le-native-pdp').forEach(bind);
  }
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
